import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';
import { ConfigurationService } from './configuration.service';
import { Configuration } from './configuration.model';

@Injectable()
export class HttpUtilityServiceImpl {
    private configuration: Configuration;
    constructor(private configurationService: ConfigurationService) {
        this.configuration = configurationService.configuration;
    }

    buildUrl(pathAndParameters: string): string {

        const combinedUrl = `${this.configuration.baseUrl}/${pathAndParameters}`;

        return combinedUrl;
    }

    getUrl(path: string): string {

        return `${this.configuration.baseUrl}/${path}`;
    }

    getHeaders(): Headers {
        const headers = new Headers();
        headers.append('Ocp-Apim-Subscription-Key', this.configuration.subscriptionKey);

        return headers;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/http-utility-impl.service.ts